import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import {
  ProjectRevenueTable,
  IndividualRevenueTable,
  ExpenditureSummaryTable,
  ProjectInformationTable,
  ToggleButton,
} from '../table/table-overview'
import * as CONSTANTS from '../constants'
import { projectInformationAction } from '../../../actions'
import { projectInformationSelector } from '../../../selectors'
import { modalButtons } from '../../buttons/modal-button'
import {
  ChangeProjectStatusForm,
  ConfirmChangeStatusForm,
  SubmitProjectForm,
} from '../form'
import { submitButton } from '../helper/button'

class OverviewTab extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'editProjectInfo') !== get(prevState, 'editProjectInfo')) {
      set(tempState, 'editProjectInfo', get(nextProps, 'editProjectInfo'))
    }
    if (get(nextProps, 'editBreakDown') !== get(prevState, 'editBreakDown')) {
      set(tempState, 'editBreakDown', get(nextProps, 'editBreakDown'))
    }
    if (get(nextProps, 'checkSubmitProjectInformationData.checkSubmit') !== get(prevState, 'checkSubmitProjectInformationData.checkSubmit')) {
      set(tempState, 'checkSubmitProjectInformationData.checkSubmit', get(nextProps, 'checkSubmitProjectInformationData.checkSubmit'))
    }
    return tempState
  }

  state={
    activeToggle: 1,
    editProjectInfo: false,
    editBreakDown: false,
    showChangeStatus: false,
    showConfirmChangeStatus: false,
    showSubmit: false,
    showApprove: false,
    showReject: false,
    changeProjectStatus: '',
    submit_remark: '',
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(this.state) === JSON.stringify(nextState)) return false
    return true
  }

  clickToggleButton = (toggle) => {
    this.setState({ activeToggle: toggle })
  }

  clickChangeStatus = (type) => {
    switch (type) {
      case 'apply': {
        this.setState({ showChangeStatus: !this.state.showChangeStatus })
        if (this.state.changeProjectStatus === CONSTANTS.IMPLEMENTING) {
          this.setState({ showConfirmChangeStatus: !this.state.showConfirmChangeStatus })
        } else {
          const changeProjectStatus = this.state.changeProjectStatus === '' ? get(this.props, 'changeableProjectStatus')[0] : this.state.changeProjectStatus
          this.props.changeStatusProjectInformation(
            get(this.props, 'projectID'),
            { project_status: changeProjectStatus },
            localStorage.getItem('access_token'))
        }
        break
      }
      case 'cancel': {
        this.setState({
          showChangeStatus: !this.state.showChangeStatus,
          changeProjectStatus: '',
        })
        break
      }
      case 'confirm': {
        const changeProjectStatus = this.state.changeProjectStatus === '' ? get(this.props, 'changeableProjectStatus')[0] : this.state.changeProjectStatus
        this.props.changeStatusProjectInformation(
          get(this.props, 'projectID'),
          { project_status: changeProjectStatus },
          localStorage.getItem('access_token'))
        this.setState({
          showConfirmChangeStatus: !this.state.showConfirmChangeStatus,
          changeProjectStatus: '',
        })
        break
      }
      case 'cancel_confirm': {
        this.setState({
          showConfirmChangeStatus: !this.state.showConfirmChangeStatus,
          changeProjectStatus: '',
        })
        break
      }
      default: break
    }
  }

  closeResponseModal = () => {
    this.props.openResponseModal({ responseModal: { isOpen: false, res: {} } })
  }

  editProjectInformation = (state) => {
    if (state.start_date === ''
    || state.end_date === ''
    || state.project_name === ''
    || state.company_id === ''
    || state.lob_id === ''
    || !state.client.value
    || !state.key_project_manager
    || !state.project_managers.length === 0) {
      const actions = { close: this.closeResponseModal }
      this.props.openResponseModal({
        responseModal: {
          isOpen: true,
          res: {
            type: 'error',
            title: 'Error',
            description: 'Please recheck the required field in project information details',
            actions: modalButtons('error', actions),
          },
        },
      })
    } else {
      const access_token = localStorage.getItem('access_token')
      const payload = { ...state.projectByID }
      delete payload.project_type
      delete payload.created
      delete payload.project_approve_status
      delete payload.created_by
      delete payload.project_number
      delete payload.__v
      delete payload.project_status
      delete payload.can_edit
      delete payload._id
      delete payload.updated_by
      payload.name = state.project_name
      payload.client_id = state.client._id
      payload.start_date = state.start_date
      payload.end_date = state.end_date
      payload.project_code = state.project_code
      payload.qt_number = state.project_qt_number
      payload.project_supervisor_id = (state.pm_supervisor && state.pm_supervisor.length !== 0) ? state.pm_supervisor._id : ''
      payload.key_project_manager_id = state.key_project_manager ? state.key_project_manager._id : ''
      payload.company_id = state.company_id
      payload.lob_id = state.lob_id
      payload.department_id = state.department_id
      payload.description = state.description
      payload.display_on_resource_utilization = state.display_on_resource_utilization
      const approvers = []
      const managers = []
      state.project_managers.forEach(m => { managers.push(m.value) })
      payload.project_manager_ids = managers
      state.project_approvers.forEach(p => { approvers.push(p.value) })
      payload.project_approver_ids = approvers
      this.props.editProjectInformation(get(this.props, 'projectID'), payload, access_token)
      get(this.props, 'clickEditProjectInfo')()
    }
  }

  editBreakDownRevenues = (state) => {
    const access_token = localStorage.getItem('access_token')
    const payload = { ...state.projectByID }
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    payload.project_hardware_ratio_minimum = parseFloat(state.project_hardware_ratio_minimum)
    payload.project_hardware_contract_price = parseFloat(state.project_hardware_contract_price)
    payload.project_license_ratio_minimum = parseFloat(state.project_license_ratio_minimum)
    payload.project_license_contract_price = parseFloat(state.project_license_contract_price)
    payload.project_service_contract_price = parseFloat(state.project_service_contract_price)
    payload.project_service_ratio_minimum = parseFloat(state.project_service_ratio_minimum)
    payload.project_other_service_ratio_minimum = parseFloat(state.project_other_service_ratio_minimum)
    payload.project_other_service_contract_price = parseFloat(state.project_other_service_contract_price)
    this.props.editProjectInformation(get(this.props, 'projectID'), payload, access_token)
    get(this.props, 'clickEditBreakDown')()
  }

  clickCalculate = (state) => {
    const access_token = localStorage.getItem('access_token')
    const payload = { ...state.projectByID }
    delete payload.project_type
    delete payload.created
    delete payload.workDays
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload.can_edit
    delete payload._id
    delete payload.updated_by
    payload.project_hardware_ratio_minimum = parseFloat(state.project_hardware_ratio_minimum)
    payload.project_hardware_contract_price = parseFloat(state.project_hardware_contract_price)
    payload.project_license_ratio_minimum = parseFloat(state.project_license_ratio_minimum)
    payload.project_license_contract_price = parseFloat(state.project_license_contract_price)
    payload.project_service_ratio_minimum = parseFloat(state.project_service_ratio_minimum)
    payload.project_service_contract_price = parseFloat(state.project_service_contract_price)
    payload.project_other_service_ratio_minimum = parseFloat(state.project_other_service_ratio_minimum)
    payload.project_other_service_contract_price = parseFloat(state.project_other_service_contract_price)
    this.props.editProjectInformation(get(this.props, 'projectID'), payload, access_token, false)
  }

  clickApproveOrReject = (type) => {
    switch (type) {
      case 'Approve': {
        const access_token = localStorage.getItem('access_token')
        this.props.checkSubmitProjectInformation(
          get(this.props, 'projectID'), { remark: this.state.submit_remark }, access_token)
        this.setState({ showApprove: !this.state.showApprove })
        break
      }
      case 'Reject': {
        const access_token = localStorage.getItem('access_token')
        this.props.checkSubmitProjectInformation(
          get(this.props, 'projectID'), { remark: this.state.submit_remark }, access_token)
        this.setState({ showReject: !this.state.showReject })
        break
      }
      default: break
    }
  }

  clickSubmitProject = () => {
    const access_token = localStorage.getItem('access_token')
    this.props.checkSubmitProjectInformation(
      get(this.props, 'projectID'), { remark: this.state.submit_remark }, access_token)
    this.setState({ showSubmit: !this.state.showSubmit })
  }

  submitProject = () => {
    const access_token = localStorage.getItem('access_token')
    this.props.submitProjectInformation(
      get(this.props, 'projectID'), { remark: this.state.submit_remark, is_submit: true }, access_token)
    this.closeSubmitModal()
  }

  approveOrReject = (type) => {
    const access_token = localStorage.getItem('access_token')
    this.props.approveProjectInformation(
      get(this.props, 'projectID'), {
        remark: this.state.submit_remark,
        is_approve: type === 'approveProject',
      }, access_token)
    this.closeSubmitModal()
  }

  closeSubmitModal = () => {
    this.setState({
      showSubmit: false,
      showApprove: false,
      showReject: false,
      submit_remark: '',
    })
    this.props.resetCheckSubmitProjectInformation()
  }

  selectHeaderForm = () => {
    if (this.state.showSubmit) return 'Submit'
    else if (this.state.showApprove) return 'Approve'
    else if (this.state.showReject) return 'Reject'
    return null
  }

  selectTypeForm = () => {
    if (this.state.showSubmit) return 'submitProject'
    else if (this.state.showApprove) return 'approveProject'
    else if (this.state.showReject) return 'rejectProject'
    return null
  }

  /* eslint no-underscore-dangle: 0 */
  render() {
    const clickEditProjectInfo = get(this.props, 'clickEditProjectInfo')
    const clickEditBreakDown = get(this.props, 'clickEditBreakDown')
    const projectType = get(this.props, 'projectByID.project_type')
    return (
      <Wrapper>
        { this.state.showConfirmChangeStatus &&
        <ConfirmChangeStatusForm
          open={ this.state.showConfirmChangeStatus }
          clickChangeStatus={ this.clickChangeStatus }
        /> }
        { this.state.showChangeStatus &&
        <ChangeProjectStatusForm
          open={ this.state.showChangeStatus }
          changeProjectStatus={ this.state.changeProjectStatus }
          changeableProjectStatus={ get(this.props, 'changeableProjectStatus') }
          handleStatus={ (e) => this.setState({ changeProjectStatus: e.target.value }) }
          clickChangeStatus={ this.clickChangeStatus }
        /> }
        <SubmitProjectForm
          open={
            this.state.showSubmit
            || this.state.showApprove
            || this.state.showReject
          }
          status={ this.selectHeaderForm() }
          button={ submitButton(
            this.selectTypeForm(),
            () => this.submitProject(),
            (type) => this.approveOrReject(type),
            () => this.closeSubmitModal())
          }
          projectByID={ get(this.props, 'projectByID') }
          // projectSubmit={ get(this.props, 'projectSubmit') }
          checkSubmit={ get(this.props.checkSubmitProjectInformationData, 'checkSubmit.sumDiffProjectCost', {}) }
          canSeeOverallCost={ get(this.props.checkSubmitProjectInformationData, 'checkSubmit.can_see_overall_cost', false) }
          handleInput={ (e) => this.setState({ submit_remark: e.target.value }) }
          toggle={ () => this.closeSubmitModal() }
        />
        { projectType !== CONSTANTS.COMMON &&
          <div>
            <ToggleButton
              projectByID={ get(this.props, 'projectByID') }
              id={ get(this.props, 'id') }
              $canSeeOverviewStandard={ get(this.props, 'projectByID.$canSeeOverviewStandard') }
              $canSeeOverviewActual={ get(this.props, 'projectByID.$canSeeOverviewActual') }
              selectedVersion={ get(this.props, 'selectedVersion') }
              project_managers={ get(this.props, 'project_managers') }
              clickToggleButton={ this.clickToggleButton }
              activeToggle={ this.state.activeToggle }
              clickSubmitProject={ this.clickSubmitProject }
              saveSnapshot={ (payload) =>
                this.props.saveSnapshot(get(this.props, 'projectID'), payload, localStorage.getItem('access_token')) }
            />
            <ProjectRevenueTable
              activeToggle={ this.state.activeToggle }
              rSelected={ get(this.props, 'rSelected') }
              id={ get(this.props, 'id') }
              projectByID={ get(this.props, 'projectByID') }
              // projectSubmit={ get(this.props, 'projectSubmit') }
              project_managers={ get(this.props, 'project_managers') }
              canSeeOverviewStandard={ get(this.props, 'projectByID.$canSeeOverviewStandard') }
              canSeeOverviewActual={ get(this.props, 'projectByID.$canSeeOverviewActual') }
            />
            <IndividualRevenueTable
              activeToggle={ this.state.activeToggle }
              rSelected={ get(this.props, 'rSelected') }
              projectByID={ get(this.props, 'projectByID') }
              // projectSubmit={ get(this.props, 'projectSubmit') }
              editBreakDown={ this.state.editBreakDown }
              clickEdit={ () => clickEditBreakDown() }
              clickCalculate={ this.clickCalculate }
              editBreakDownRevenues={ this.editBreakDownRevenues }
              cancelEdit={ () => {
                clickEditBreakDown()
                this.props.getProjectInformationByID(get(this.props, 'projectID'), localStorage.getItem('access_token'))
              } }
            />
            <ExpenditureSummaryTable
              activeToggle={ this.state.activeToggle }
              rSelected={ get(this.props, 'rSelected') }
              projectByID={ get(this.props, 'projectByID') }
            />
          </div>
        }
        <ProjectInformationTable
          rSelected={ get(this.props, 'rSelected') }
          activeToggle={ this.state.activeToggle }
          editProjectInfo={ this.state.editProjectInfo }
          projectByID={ get(this.props, 'projectByID') }
          users={ get(this.props, 'users') }
          clients={ get(this.props, 'clients') }
          companys={ get(this.props, 'companys') }
          lobs={ get(this.props, 'lobs') }
          departments={ get(this.props, 'departments') }
          last_submit_request={ get(this.props, 'last_submit_request') }
          editProjectInformation={ this.editProjectInformation }
          clickApproveOrReject={ this.clickApproveOrReject }
          clickChangeStatus={ () =>
            this.setState({ showChangeStatus: !this.state.showChangeStatus }) }
          clickEdit={ () => clickEditProjectInfo() }
          cancelEdit={ () => {
            clickEditProjectInfo()
            this.props.getProjectInformationByID(get(this.props, 'projectID'), localStorage.getItem('access_token'))
          } }
        />
      </Wrapper>
    )
  }
}

OverviewTab.propTypes = {
  changeStatusProjectInformation: PropTypes.func,
  getProjectInformationByID: PropTypes.func,
  editProjectInformation: PropTypes.func,
  submitProjectInformation: PropTypes.func,
  approveProjectInformation: PropTypes.func,
  saveSnapshot: PropTypes.func,
}
OverviewTab.defaultProps = {
  changeStatusProjectInformation: () => {},
  getProjectInformationByID: () => {},
  editProjectInformation: () => {},
  submitProjectInformation: () => {},
  approveProjectInformation: () => {},
  saveSnapshot: () => {},
}

const mapStateToProps = (state, props) => createStructuredSelector({
  checkSubmitProjectInformationData: projectInformationSelector.checkSubmitProjectInformationData,
  changeStatusProjectInformationData: projectInformationSelector.changeStatusProjectInformationData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  changeStatusProjectInformation: projectInformationAction.changeStatusProjectInformation,
  getProjectInformationByID: projectInformationAction.getProjectInformationByID,
  editProjectInformation: projectInformationAction.editProjectInformation,
  resetCheckSubmitProjectInformation: projectInformationAction.resetCheckSubmitProjectInformation,
  checkSubmitProjectInformation: projectInformationAction.checkSubmitProjectInformation,
  submitProjectInformation: projectInformationAction.submitProjectInformation,
  saveSnapshot: projectInformationAction.saveSnapshot,
  openResponseModal: projectInformationAction.openResponseModal,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(OverviewTab)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-overview.js